import cx from 'classnames';
import styles from './RestaurantEventManagementModal.scss';

export type EventFormStep = { id: string; label: string };

export const EventFormStepIndicators = ({
  steps,
  activeStepId,
  onStepClick,
}: {
  steps: readonly EventFormStep[];
  activeStepId: string;
  onStepClick: (stepId: string) => void;
}) => (
  <div className={styles.stepIndicators}>
    {steps.map((step, idx) => {
      const isActive = step.id === activeStepId;
      const activeIndex = steps.findIndex(
        (candidateStep) => candidateStep.id === activeStepId,
      );
      return (
        <button
          key={step.id}
          type="button"
          aria-label={`Section ${idx + 1}: ${step.label}`}
          aria-current={isActive ? 'step' : undefined}
          className={cx(styles.stepIndicator, {
            [styles.activeStepIndicator]: isActive,
            [styles.stepVisited]: idx < activeIndex,
          })}
          onClick={() => onStepClick(step.id)}
        />
      );
    })}
  </div>
);
